import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { Designable, DesignService, FxLayoutAlignDirective, FxLayoutDirective, FxLayoutGapDirective, ResponsiveService } from '@rspl-ui';
import { sizeDescriptions } from 'libs/domains/src/donation-item';

export interface InfoDialogData {
  title: string;
  icon?: string;
  subtitle?: string;
  button?: string;
  color: string;
  message: string;
}

@Component({
  selector: 'app-item-remove-dialog',
  templateUrl: './item-remove-dialog.component.html',
  styleUrls: ['./item-remove-dialog.component.scss'],
  imports: [
    MatDialogTitle,
    FxLayoutDirective,
    FxLayoutGapDirective,
    MatIcon,
    FxLayoutAlignDirective,
    CdkScrollable,
    MatDialogContent,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
  ],
})
export class ItemRemoveDialogComponent extends Designable implements OnInit {
  disassembly: boolean;
  count = 1;
  cart: any;
  sizeDescriptions = sizeDescriptions;
  public constructor(
    public reference: MatDialogRef<ItemRemoveDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    protected override designService: DesignService,
    public override responsiveService: ResponsiveService,
  ) {
    super(designService, responsiveService);
  }

  override ngOnInit(): void {
    console.log(this.data);
  }

  removeItem(): void {
    this.count = this.count - 1;
  }

  addItem(): void {
    this.count = this.count + 1;
  }

  submit(): void {}
}
